import styled, { css } from 'styled-components';
import { marginBottom, margin } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
import { fontSize, fontWeight } from 'modules/theme';
const baseStyles = css `
  ${margin(0)};
  font-style: normal;
  color: ${themeGet('colors.gray.800')};
  text-align: ${(props) => props.$textAlign};
`;
const shouldDiscardMargin = (props) => props.$noMargin;
export const SubtitleContainer = styled.div `
  ${fontWeight('normal')};
  color: ${themeGet('colors.gray.700')};
  font-style: normal;
  text-align: ${(props) => props.$textAlign};
`;
export const mainStyles = css `
  ${baseStyles};
  ${fontWeight('semibold')};
  ${fontSize('xLarge', 1.5)};
  ${(props) => marginBottom(shouldDiscardMargin(props) ? 0 : 4)};

  & + ${SubtitleContainer} {
    ${(props) => marginBottom(props.$noMargin ? 0 : 4)};
    ${fontSize('base', 1.5)};
  }
`;
export const pageStyles = css `
  ${baseStyles};
  ${fontWeight('normal')};
  ${fontSize('large', 1.3)};
  ${(props) => marginBottom(shouldDiscardMargin(props) ? 0 : 4)};

  & + ${SubtitleContainer} {
    ${(props) => marginBottom(props.$noMargin ? 0 : 4)};
    ${fontSize('base', 1.5)};
  }
`;
export const sectionStyles = css `
  ${baseStyles};
  ${fontWeight('semibold')};
  ${fontSize('infrequent', 1.5)};
  ${(props) => marginBottom(shouldDiscardMargin(props) ? 0 : 3)};

  & + ${SubtitleContainer} {
    ${(props) => marginBottom(props.$noMargin ? 0 : 3)};
    ${fontSize('base', 1.5)};
  }
`;
export const subsectionStyles = css `
  ${baseStyles};
  ${fontWeight('semibold')};
  ${fontSize('base', 1.5)};
  ${(props) => marginBottom(shouldDiscardMargin(props) ? 0 : 3)};

  & + ${SubtitleContainer} {
    ${(props) => marginBottom(props.$noMargin ? 0 : 3)};
    ${fontSize('small', 1.5)};
  }
`;
export const labelStyles = css `
  ${baseStyles};
  ${fontWeight('semibold')};
  ${fontSize('small', 1.5)};
  ${(props) => marginBottom(shouldDiscardMargin(props) ? 0 : 2)};

  & + ${SubtitleContainer} {
    ${(props) => marginBottom(props.$noMargin ? 0 : 2)};
    ${fontSize('tiny', 1.5)};
  }
`;
export const TitleContainer = styled.div `
  ${(props) => props.$appearance === 'main' && mainStyles};
  ${(props) => props.$appearance === 'page' && pageStyles};
  ${(props) => props.$appearance === 'section' && sectionStyles};
  ${(props) => props.$appearance === 'subsection' && subsectionStyles};
  ${(props) => props.$appearance === 'label' && labelStyles};
`;
